import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useRider } from '../context/RiderContext';
import { saveFcmToken, requestNotificationPermission } from '../services/firebase';
import { unlockAudio } from '../utils/alertSound';
import { useLanguage } from '../i18n/LanguageContext';

export default function NotificationPrompt() {
  const { rider } = useRider();
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!rider || !('Notification' in window)) return;
    setVisible(Notification.permission === 'default');
  }, [rider]);

  if (!visible) return null;

  const enable = async () => {
    unlockAudio();
    const perm = await requestNotificationPermission();
    if (perm !== 'granted') {
      setVisible(false);
      if (perm === 'denied') toast.error(t('notifications.blocked'));
      else toast.error(t('notifications.failed'));
      return;
    }
    const ok = await saveFcmToken(rider.uid);
    setVisible(false);
    if (ok) toast.success(t('notifications.enabled'));
    else toast.error(t('notifications.failed'));
  };

  return (
    <div className="notification-prompt" role="region" aria-label={t('notifications.title')}>
      <div>
        <div className="notification-prompt__title">🔔 {t('notifications.title')}</div>
        <div className="notification-prompt__desc">{t('notifications.desc')}</div>
      </div>
      <button type="button" className="notification-prompt__btn" onClick={enable}>
        {t('notifications.enable')}
      </button>
    </div>
  );
}
